
import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { GenSpecialProgram } from '../../models/special-program.model';
import { GenCustomerService } from '../../services/customer.service';
import { Observable, Subject, switchMap, take, takeUntil, tap } from 'rxjs';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { RoutingService, WindowRef } from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'gen-special-program',
  templateUrl: './special-program.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenSpecialProgramComponent implements OnDestroy {
  readonly iconType = ICON_TYPE;
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly customerService = inject(GenCustomerService);
  private readonly userService = inject(UserAccountFacade);
  private readonly activeCartService = inject(ActiveCartFacade);
  private readonly winRef = inject(WindowRef);
  private readonly routingService = inject(RoutingService);
  private userId: string;
  private destroy$ = new Subject();

  selectedSpecialProgramCode: string;
  specialPrograms$: Observable<GenSpecialProgram[]> = this.userService.get().pipe(
    tap(user => this.userId = user?.uid),
    switchMap(() => this.activeCartService.takeActive()),
    tap(cart => this.selectedSpecialProgramCode = cart?.specialProgram),
    switchMap(() => this.customerService.getSpecialPrograms()),
    tap((specialPrograms) => {
      if (!this.selectedSpecialProgramCode) {
        this.selectedSpecialProgramCode = specialPrograms.length > 0 ? specialPrograms[0].code : null;
      }
    })
  );

  selectSpecialProgram(specialProgramCode: string): void {
    this.selectedSpecialProgramCode = specialProgramCode;
    this.customerService.setSpecialProgram(this.userId, specialProgramCode)
      .pipe(take(1), takeUntil(this.destroy$), tap(() => {
        if (this.winRef.location.href.includes('/checkout')) {
          this.routingService.go({ cxRoute: 'cart' });
        } else if (this.winRef.location.search.includes('currentPage=')) {
          this.clearCurrentPageQueryParam();
        }
      }))
      .subscribe();
  }

  // Reset pagination on Special Program change to prevent staying on a previous page
  //  (e.g., ?currentPage=3).
  private clearCurrentPageQueryParam(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { currentPage: null },
      queryParamsHandling: 'merge'
    });
  }

  pauseCarouselAutoplay(): void {
    window.dispatchEvent(new CustomEvent('pauseCarousel'));
  }

  resumeCarouselAutoplay(): void {
    window.dispatchEvent(new CustomEvent('resumeCarousel'));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
